//篮球 联赛 cba full
import PlatfromBasketballLeagueFullCBA from '@containers/platfrom_basketball/basketballLeagueFull_cba.vue'

export default {
  PlatfromBasketballLeagueFullCBA,
}
